<script lang="ts">
    export let type = "button";
    export let disabled = false;
    export let className : "primary" | "secondary" | "tertiary" = "primary";
</script>

<button {type} {disabled} on:click class={className} >
    <slot />
</button>

<style>
    button {
        border: 0;
        border-radius: 8px;
        width: 100px;
        height: 40px;
        cursor: pointer;
    }

    

    button:hover {
        transform: scale(0.98);
        opacity: 0.9;
    }

    button:disabled {
        background-color: #cccccc;
        color: #333;
        cursor: auto;
    }

    button:disabled:hover {
        transform: scale(1);
        opacity: 1;
    }

    button.primary {
        background-color: var(--primary-color);
        color: var(--primary-contrast);
        font-weight: bold;
    }

    button.secondary {
        background-color: var(--secondary-color);
        color: var(--secondary-contrast);
        font-weight: bold;
    }

    button.primary:disabled, button.secondary:disabled {
        background-color: var(--disabled-color);
        color: var(--disabled-contrast);
        font-weight: bold;
    }

</style>
